import React from "react";
import TotalBlock from "./totalBlock";

const Total = (props) => {
  const { data, darkMode } = props;
  return (
    <div className="total">
      <div className="total-grid">
        {data.map((elem) => {
          return <TotalBlock dataBlock={elem} darkMode={darkMode} />;
        })}
      </div>
    </div>
  );
};

export default Total;
